import { getModule } from 'vuex-module-decorators'
import store from '@/store'
import CommonTopicService from '@/services/CommonTopicService'
import UserInfo from '@/store/modules/UserInfo'

const UserModule = getModule(UserInfo, store)

let inflight: Promise<void> | null = null

export function isCommonTopicPath(path: string): boolean {
  return path.startsWith('/common-topic')
}

/** Loads common-topic edit permission into `user.common_topic_role`. */
export function fetchCommonTopicEditRole(): Promise<void> {
  if (!store.state.auth.token) {
    UserModule.UPDATE_USER_COMMON_TOPIC_ROLE(false)
    return Promise.resolve()
  }
  if (inflight != null) {
    return inflight
  }
  inflight = CommonTopicService.getRolesEditCommonTopic()
    .then(res => {
      if (res.status === 200) {
        UserModule.UPDATE_USER_COMMON_TOPIC_ROLE(
          res.data.role_edit_common_topic === 1
        )
      }
    })
    .catch(() => {
      UserModule.UPDATE_USER_COMMON_TOPIC_ROLE(false)
    })
    .finally(() => {
      inflight = null
    })
  return inflight
}
